import React from 'react';
import { CalculatorContextType } from '../../../../services/types/Calculator';

const Context = React.createContext<CalculatorContextType>({
  name: '',
  countries: [],
  sectors: [],
  enable: true,
  lastVersion: 0,
  blocked: false,
  flowTypeBlockedBy: '',
  stepBlockedBy: '',
  reload: () => {},
  unitId: 0,
  isMember: false,
});

export default Context;
